import { VerticalAlignmentBottom, VerticalAlignmentCenter, VerticalAlignmentTop } from 'almanac-ui/icons'
import cx from 'classnames'
import { setAlignment } from 'common/Prose/Commands/table/mutation'
import { isTableCell } from 'common/Prose/utils/table'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { type EditorView } from 'prosemirror-view'
import { useMemo } from 'react'
import Styles from './VerticalAlignmentPicker.module.scss'

interface Props {
  closePicker?: () => void
  includeDropdownStyles?: boolean
  view: EditorView
}

const alignments = [
  {
    icon: VerticalAlignmentTop,
    title: 'Top',
    verticalAlign: 'top',
  },
  {
    icon: VerticalAlignmentCenter,
    title: 'Centered',
    verticalAlign: 'middle',
  },
  {
    icon: VerticalAlignmentBottom,
    title: 'Bottom',
    verticalAlign: 'bottom',
  },
] as const

type verticalAlignments = (typeof alignments)[number]['verticalAlign']

export const VerticalAlignmentPicker = ({ closePicker, includeDropdownStyles = true, view }: Props) => {
  const activeAlignments = useMemo(() => {
    const foundAlignments = new Set<verticalAlignments>()
    const { selection } = view.state

    for (let {
      $from: { pos: from },
      $to,
    } of selection.ranges) {
      view.state.doc.nodesBetween(from, $to.pos, (node, pos) => {
        if (isTableCell(node)) foundAlignments.add(node.attrs.verticalAlign || 'top')
      })
    }
    return foundAlignments
  }, [view.state])

  return (
    <div className={cx({ [Styles.dropdownContainer]: includeDropdownStyles })}>
      <div className={Styles.alignmentOptions}>
        {alignments.map((alignment) => {
          return (
            <InlineFormatDropdownMenuItem
              key={alignment.title}
              active={activeAlignments.has(alignment.verticalAlign)}
              onClick={() => {
                setAlignment(alignment.verticalAlign)(view.state, view.dispatch)
                closePicker?.()
              }}
              icon={<alignment.icon />}
              label={alignment.title}
            />
          )
        })}
      </div>
    </div>
  )
}
